import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const GlobalBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide the back button on the Home page
  const isHome = location.pathname === '/';
  
  // Hide the back button on specific dynamic pages that have their own headers
  const hideOnPrefixes = ['/state/', '/place/'];
  const isPrefixed = hideOnPrefixes.some(prefix => location.pathname.startsWith(prefix));

  if (isHome || isPrefixed) return null;

  return (
    <button 
      onClick={() => navigate(-1)}
      style={{
        position: 'fixed',
        bottom: '30px',
        left: '30px',
        zIndex: 99999, // 👈 Pushed to the absolute top layer so nothing covers it
        backgroundColor: '#111827',
        color: 'white',
        padding: '12px 24px',
        borderRadius: '50px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '15px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={(e) => { 
        e.currentTarget.style.backgroundColor = '#374151'; 
        e.currentTarget.style.transform = 'translateY(-3px)'; 
      }}
      onMouseLeave={(e) => { 
        e.currentTarget.style.backgroundColor = '#111827'; 
        e.currentTarget.style.transform = 'translateY(0)'; 
      }}
    >
      <ArrowLeft size={18} /> Back
    </button>
  );
};

export default GlobalBackButton;